import React from "react";
import { Drawer as KendoDrawer, DrawerContent } from "@progress/kendo-react-layout";
import { useDispatch, useSelector } from "react-redux";
import { CONTENT_DRAWER, setDrawerClose, USER_DRAWER } from "../../store/actions/drawerActions";
import { UserDrawer } from "./Views/UserDrawer";
import { ContentDrawer } from "./Views/ContentDrawer";

export const Drawer = () => {
  const { drawerVisible, drawerID } = useSelector(state => state.drawerReducer);
  const dispatch = useDispatch();

  return (
    <KendoDrawer
      expanded={drawerVisible}
      mode={'overlay'}
      animation={{
        duration: 400
      }}
      position='end'
      width={400}
      onOverlayClick={() => dispatch(setDrawerClose)}
      items={[{}]} // array of single empty object to render the custom item
      item={(props) => {
        if (drawerID === USER_DRAWER) {
          return (<UserDrawer {...props} />)
        } else if (drawerID === CONTENT_DRAWER) {
          return (<ContentDrawer {...props} />)
        } else {
          return (<div>Drawer Content</div>)
        }
      }}
    />
  )
}